const STORAGE_KEY = 'audocph_b2b_mode';

function normalizePath(path) {
  if (!path) return '/';
  try {
    path = new URL(path, window.location.origin).pathname;
  } catch (e) {
    // Already a path
  }
  const stripped = path.replace(/\/+$/, '');
  return stripped === '' ? '/' : stripped;
}

function isStorefrontHomepage() {
  if (document.documentElement.getAttribute('data-b2b-page-type') === 'index') {
    return true;
  }
  const homeLink = document.querySelector('[data-b2b-home-link]');
  const privateHome = homeLink?.getAttribute('data-b2b-private-home') || '/';
  return normalizePath(window.location.pathname) === normalizePath(privateHome);
}

function resolveMode() {
  let mode = 'privat';
  try {
    mode = localStorage.getItem(STORAGE_KEY) || 'privat';
  } catch (e) {
    return 'privat';
  }

  if (mode === 'professional' && isStorefrontHomepage()) {
    mode = 'privat';
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      // Ignore storage errors (private mode, quota, etc.)
    }
  }

  return mode;
}

function applyHomeLinks(mode) {
  document.querySelectorAll('[data-b2b-home-link]').forEach((link) => {
    const professionalHome = link.getAttribute('data-b2b-professional-home');
    const privateHome = link.getAttribute('data-b2b-private-home') || '/';
    link.href = mode === 'professional' && professionalHome ? professionalHome : privateHome;
  });
}

class B2BSwitcher extends HTMLElement {
  constructor() {
    super();
    this.STORAGE_KEY = STORAGE_KEY;
    this.buttons = this.querySelectorAll('[data-b2b-mode]');
    this.init();
  }

  init() {
    this.setActiveMode(resolveMode(), false);

    this.buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const mode = e.currentTarget.dataset.b2bMode;
        const landingPage = e.currentTarget.dataset.landingPage;

        localStorage.setItem(this.STORAGE_KEY, mode);
        this.setActiveMode(mode, true);

        // Dispatch event for header to swap menus
        document.dispatchEvent(
          new CustomEvent('b2b:mode-changed', { detail: { mode } })
        );

        // Navigate to landing page on first click to professionals
        if (landingPage && window.location.pathname !== landingPage) {
          window.location.href = landingPage;
        }
      });
    });
  }

  setActiveMode(mode, broadcast) {
    this.buttons.forEach((btn) => {
      const isActive = btn.dataset.b2bMode === mode;
      btn.classList.toggle('b2b-switcher__btn--active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    // Update all other switchers on the page
    if (broadcast) {
      document.querySelectorAll('[data-b2b-switcher]').forEach((switcher) => {
        if (switcher !== this) {
          switcher.querySelectorAll('[data-b2b-mode]').forEach((btn) => {
            const isActive = btn.dataset.b2bMode === mode;
            btn.classList.toggle('b2b-switcher__btn--active', isActive);
            btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        }
      });
    }

    // Swap menu visibility class on <html> (mirrors the inline script that runs before render)
    document.documentElement.classList.toggle('b2b-professional', mode === 'professional');
    document.documentElement.classList.toggle('b2b-private', mode !== 'professional');

    applyHomeLinks(mode);
  }
}

customElements.define('b2b-switcher', B2BSwitcher);

try {
  applyHomeLinks(resolveMode());
} catch (e) {
  applyHomeLinks('privat');
}
